var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:{
      'd-flex align-center justify-space-between': false,
      'text-caption field-label--text text--lighten-1':
        _vm.$vuetify.breakpoint.smAndDown,
      'text-body-2': _vm.$vuetify.breakpoint.mdAndUp,
    },style:({
      color: 'rgba(0,0,0,.6)',
    })},[_vm._t("label",function(){return [_c('div',[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.required)?_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(" *"))]):_vm._e()])]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }